import { render, staticRenderFns } from "./DepartmentTreeNode.vue?vue&type=template&id=3b154de5&"
import script from "./DepartmentTreeNode.vue?vue&type=script&lang=js&"
export * from "./DepartmentTreeNode.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentTreeNode.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports